export enum DialogBoxEnum{
info = 'Info',
warn = 'Warning',
error = 'error'
}
export enum DialogBoxSizeEnum{
    large='lg',
    small='sm',
    medium='md'
}